import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const HabitationalEmailThread = Loadable(
  lazy(() =>
    import("./HabitationalEmailThread").then(({ HabitationalEmailThread }) => ({
      default: HabitationalEmailThread,
    }))
  )
);

export const HabitationalEmailThreadRoutes = [
  {
    path: "/habitational-policy/:customerId/email-thread/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.HABITATIONAL]}>
        <HabitationalEmailThread />
      </AuthorizedRoute>
    ),
  },
];
